import React, { useEffect, useState } from "react";
import CommonTable from "../../../components/Table/Table";

import { getSellerForVerification } from "../../../services/Users/User.service";
import { SellerTypes } from "../../../services/Users/User.types";

const SellerVerification: React.FC = () => {
  const [seller, setSeller] = useState<SellerTypes | null>(null);
  const [open, setOpen] = useState(false);

  // 🔹 Example sellerId (normally route se aayega)
  const sellerId = 1;

  const loadSeller = async () => {
    try {
      const res = await getSellerForVerification(sellerId);
      setSeller(res);
    } catch (err) {
      console.error("Error fetching seller", err);
    }
  };

  useEffect(() => {
    loadSeller();
  }, []);

  const columns = [
    { key: "id", label: "#" },
    {
      key: "fullName",
      label: "Full Name",
      render: (_: any, row: SellerTypes) =>
        `${row.firstName} ${row.lastName}`,
    },
    { key: "businessName", label: "Business Name" },
    { key: "email", label: "Email" },
    { key: "mobileNumber", label: "Mobile" },
    { key: "type", label: "Type" },
    {
      key: "approvalStatus",
      label: "Status",
      render: (value: string) => (
        <span
          style={{
            padding: "4px 10px",
            borderRadius: "8px",
            background: value === "approved" ? "#d4f5d4" : "#f5d4d4",
            color: value === "approved" ? "green" : "red",
          }}
        >
          {value}
        </span>
      ),
    },
  ];

  return (
    <div className="category-container">
      {seller && (
        <CommonTable
          columns={columns}
          data={[seller]}
          actions={() => (
            <button className="action-btn edit" onClick={() => setOpen(true)}>
              View
            </button>
          )}
        />
      )}

      {/* ✅ Modal UI */}
      {open && seller && (
        <div className="modal-overlay" onClick={() => setOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Seller Verification Details</h3>

            <table className="details-table">
              <tbody>
                <tr>
                  <td><strong>Name</strong></td>
                  <td>{seller.firstName} {seller.lastName}</td>
                </tr>
                <tr>
                  <td><strong>Business Name</strong></td>
                  <td>{seller.businessName}</td>
                </tr>
                <tr>
                  <td><strong>Email</strong></td>
                  <td>{seller.email}</td>
                </tr>
                <tr>
                  <td><strong>Mobile</strong></td>
                  <td>{seller.mobileNumber}</td>
                </tr>
                <tr>
                  <td><strong>City</strong></td>
                  <td>{seller.city}</td>
                </tr>
                <tr>
                  <td><strong>State</strong></td>
                  <td>{seller.state}</td>
                </tr>
                <tr>
                  <td><strong>Seller Type</strong></td>
                  <td>{seller.type}</td>
                </tr>
                <tr>
                  <td><strong>PAN Number</strong></td>
                  <td>{seller.panNumber}</td>
                </tr>
                <tr>
                  <td><strong>Aadhaar Number</strong></td>
                  <td>{seller.aadhaarNumber}</td>
                </tr>
                <tr>
                  <td><strong>GST Number</strong></td>
                  <td>{seller.gstNumber}</td>
                </tr>
                <tr>
                  <td><strong>Document Verified</strong></td>
                  <td>{seller.documentVerified ? "Yes" : "No"}</td>
                </tr>
              </tbody>
            </table>

            <button className="add-btn" onClick={() => setOpen(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SellerVerification;
